import { render, staticRenderFns } from "./FreewayLandingPage.vue?vue&type=template&id=2e34e160"
import script from "./FreewayLandingPage.vue?vue&type=script&lang=js"
export * from "./FreewayLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports